import {
  NavigationConfig,
  BottomSheetComponent,
  registerBottomSheets,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';
import RewardsScreen from '../screens/RewardsScreen';
import RewardReceivedBottomSheet from './RewardReceivedBottomSheet/RewardReceivedBottomSheet';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [
    {
      name: 'Rewards',
      options: { headerShown: true },
      component: RewardsScreen,
    },
  ],
  FULL_SCREEN_MODALS: [],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const bottomSheets = {
  RewardReceivedBottomSheet,
};

registerBottomSheets('rewards', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    rewards: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}

registerNavigationHandlers<AppNavigatorParamsList, 'Rewards'>({
  Rewards(navigate) {
    navigate('/rewards');
  },
});
